import { Button, StickyPageHeader } from "../../design-v2";

export default function StackHeader({
  title,
  onBack,
  backLabel = "Back to programs",
  backBusy = false,
  trailing,
}) {
  return (
    <StickyPageHeader
      className={`lz-product-stack-header${trailing ? " lz-product-stack-header--with-trailing" : ""}`}
    >
      {/* `backBusy` maps onto the canonical Button loading contract: the button
          disables itself, reports `aria-busy` and swaps its glyph for the
          canonical spinner. `loadingLabel` is empty because the accessible name
          comes from `backLabel`. */}
      <Button
        variant="ghost"
        size="icon"
        onClick={onBack}
        aria-label={backLabel}
        isLoading={backBusy}
        loadingLabel=""
      >
        <svg className="lz-product-stack-header__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </Button>
      <h1 className="lz-product-stack-header__title">{title}</h1>
      <div className="lz-product-stack-header__trailing" aria-hidden={trailing ? undefined : "true"}>
        {trailing || null}
      </div>
    </StickyPageHeader>
  );
}
